/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sign_InInputs */

const en_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

const es_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const fr_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const de_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const ja_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン`)
};

const zh_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const ar_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الدخول`)
};

const id_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

const it_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const ru_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

const pt_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const ko_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인`)
};

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Nav_Sign_InInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_sign_in = /** @type {((inputs?: Nav_Sign_InInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sign_InInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_sign_in(inputs)
	if (locale === "es") return es_nav_sign_in(inputs)
	if (locale === "fr") return fr_nav_sign_in(inputs)
	if (locale === "de") return de_nav_sign_in(inputs)
	if (locale === "ja") return ja_nav_sign_in(inputs)
	if (locale === "zh") return zh_nav_sign_in(inputs)
	if (locale === "ar") return ar_nav_sign_in(inputs)
	if (locale === "id") return id_nav_sign_in(inputs)
	if (locale === "it") return it_nav_sign_in(inputs)
	if (locale === "ru") return ru_nav_sign_in(inputs)
	if (locale === "pt") return pt_nav_sign_in(inputs)
	return ko_nav_sign_in(inputs)
});